export default "__VITE_ASSET__357a3a48__"